<template>
    <modal name="item-filter-curation-request-filter" class="filter-modal item-filter-curation-request-filter"
           :width="`calc(100% - 28px)`" :height="`auto`" :pivotY="0.5"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div>
            <div class="filter_modal_wrap">
                <div class="filter_modal_top">
                    <div class="filter_img"></div>
                    <div class="filter_name">{{ $t('filter') }}</div>
                    <div class="close_btn" @click="modalClose()"></div>
                </div>

<!--                <div class="mt20 filter_modal_status">
                    <div class="modal_title">{{ $t('exposure') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-radio-group v-model="sortOption"
                                               @change="sortChange(sortOption)">
                                <el-radio :label="'last_update'">{{ $t('b_update') }}</el-radio>
                                <el-radio :label="'im_real_hit'" >{{ $t('b_enter_m') }}</el-radio>
                                <el-radio :label="'im_real_like'">{{ $t('b_like') }}</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>-->

                <div class="mt20 filter_modal_edition">
                    <div class="modal_title">{{ $t('edition') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterEdition"
                                               @change="setFilterFunc('ed', filterEdition)">
                                <el-checkbox :label="1">{{ $t('edition') }}</el-checkbox>
                                <el-checkbox :label="0">{{ $t('single') }}</el-checkbox>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>

                <div class="mt20 filter_modal_type">
                    <div class="modal_title">{{ $t('type') }}</div>
                    <div class="check_wrap">
                        <div class="checkbox inline_block">
                            <el-checkbox-group v-model="filterType"
                                               @change="setFilterFunc('ty', filterType)">
                                <el-checkbox :label="'digital'">{{ $t('digital') }}</el-checkbox>
                                <el-checkbox :label="'real'">{{ $t('real') }}</el-checkbox>
                            </el-checkbox-group>
                        </div>

                    </div>
                </div>

                <div class="wrapper_bottom">
                    <button class="" @click="modalClose">{{ $t('apply2') }}</button>
                </div>

            </div>
        </div>
    </modal>
</template>

<script>
import util from "@/mixins/util";
import itemUtil from "@/components/item/itemUtil";

const {filterConfig} = itemUtil;
export default {
    name: "ItemFilterCurationRequestFilter",
    mixins: [],
    components: {},
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        modalLayout: '',
    },
    data() {
        return {
            component: null,
            sortData: {},
            filterData: {},
            searchInputOption: 'ina',
            sort: '',
            sortOption: 'last_update',
            searchInput: '',
            filterCategory: [],
            filterStatus: [],
            filterEdition: [],
            filterType: [],
            priceInput: ['', ''],
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            this.sortData = event.params.sortData;
            this.filterData = event.params.filterData;
            this.setterFilterDataInData();
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        modalClose() {
            this.$modal.hide('item-filter-curation-request-filter');
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
            if (!util.isEmpty(this.sortData.key)) {
                this.sortOption = this.sortData.key;
            }
        },
        sortChange(data) {
            if (data === 'priceAsc') {
                this.sort = 'asc'
                this.setSort('i_price', 'asc');
            } else if (data === 'priceDesc') {
                this.sort = 'desc'
                this.setSort('i_price', 'desc');
            } else {
                this.sort = 'desc'
                this.setSort(data, 'desc');
            }
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
